module.exports = __webpack_public_path__ + "assets/cynergy-logo-no-text-black.a45a2dbc.svg";